<template>
  <div :style="'background:#eee;overflow: hidden;height:' + clientHeight +'px'">
      <div ref="head">
      <Card :padding="0"  style="margin-bottom: 5px;" dis-hover>
        <Row type="flex" justify="start" align="middle" style="padding:5px 10px">
          <Col span="18">
            <Row type="flex" justify="start" align="middle">
              <ButtonToolBar
                ref="menutoolbar"
                :config="menuToolbar"
                :moduleMethod="moduleMethod"
                @doAction="doAction"
              />
            </Row>
          </Col>
          <Col span="6">
            <Row type="flex" justify="end" align="middle">
              <PromptMessage />
            </Row>
          </Col>
        </Row>
      </Card>
      </div>
    <Row type="flex" justify="start" >
      <Col :span="myConfig.gridCol" style="background:#eee;padding-right: 5px">
        <Card :padding="0" :bordered="false">
          <div style="padding-top:8px;padding-bottom:8px">
            <ViewGrid
              ref="grid"
              :config="myConfig.gridConfig"
              :dictData="dictData"
              @click="gridClick"
            />
          </div>
        </Card>
      </Col>
      <Col :span="myConfig.formCol" style="background:#eee">
        <Card :padding="0" :bordered="false" dis-hover >
           <EditGrid  ref="fromgrid" :config="myConfig.fromGridConfig"  :dictData="dictData" />
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import QuickQueryToolbar from './quickquerytoolbar.vue';
import PromptMessage from './promptmessage.vue';
import elementResizeDetectorMaker from 'element-resize-detector';
export default {
    name: 'leftlistrightdetails',
    components: { QuickQueryToolbar, PromptMessage },
    data() {
        return {
            myConfig: {
                showOperLog: false,
                bindingKey: 'ph_key',
                resources: '',
                className: '',
                gridCol: 8,
                formCol: 16,
                gridConfig: {},
                adjustHeight: 160,
            },
            menuToolbar: {
                enablePermissions: true,
                items: [
                    {
                        name: 'editData',
                        text: '编辑'
                    },
                    {
                        name: 'saveData',
                        text: '保存'
                    },
                    {
                        name: 'addData',
                        text: '新增明细'
                    },
                    {
                        name: 'delData',
                        text: '删除明细'
                    }
                ]
            },
            ph_key: '',
            curlData:{}
        };
    },
    props: {
        config: {
            type: Object,
            default: null
        },
        dictData: {
            type: Object,
            default: null
        },
        moduleMethod: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    computed: {
        clientHeight () {
            return this.$Store.state.app.clientHeight;
        }
    },
    created() {
        this.myConfig = Object.assign({}, this.myConfig, this.config);
        this.myConfig.gridConfig.headStyle = '';
        this.myConfig.gridConfig.onSelectionChange = this.gridOnSelectionChange;
        this.myConfig.gridConfig.overrideData = this.gridOverrideData;
        this.myConfig.gridConfig.showCondition = false;
        this.myConfig.gridConfig.resources = this.myConfig.resources;
        this.myConfig.gridConfig.method = this.myConfig.classPrefix + '.search';
        this.myConfig.gridConfig.response = this.myConfig.response;
        this.myConfig.gridConfig.tableSize = 'small';
        this.myConfig.gridConfig.showBorder = false;
        this.myConfig.gridConfig.pageShowSizer = false;
        this.myConfig.gridConfig.height = 1;
        this.myConfig.gridConfig.adjustHeight = 0;

        this.myConfig.fromGridConfig.headStyle='';
        this.myConfig.fromGridConfig.showCondition = false;
        this.myConfig.fromGridConfig.showAddBtn = false;
        this.myConfig.fromGridConfig.showDelBatchBtn = false;
        this.myConfig.fromGridConfig.onSelectionChange = this.FromGridOnSelectionChange;
        this.myConfig.fromGridConfig.height = 1;
        this.myConfig.fromGridConfig.width = 1;
        this.myConfig.fromGridConfig.adjustHeight = 0;
        this.myConfig.fromGridConfig.adjustWidth = 0;
    
        if (this.myConfig.gridConfig.multiSelect === undefined) {
            this.myConfig.gridConfig.multiSelect = false;
        }
        this.myConfig.gridConfig.items.forEach(el => {
            if (el.type !== 'CheckBox') {
                if (el.tooltip === undefined) {
                    el.tooltip = true;
                }
            }
        });
    // 处理按钮
        if (this.myConfig.menuToolbar !== undefined) {
            for (let pro in this.myConfig.menuToolbar) {
                if (pro === 'items') {
                    if (this.myConfig.menuToolbar[pro].length > 0) {
                        this.menuToolbar[pro] = this.myConfig.menuToolbar[pro];
                    }
                } else {
                    this.menuToolbar[pro] = this.myConfig.menuToolbar[pro];
                }
            }
        }
    },
    methods: {
        search() {
            this.$refs.form.clearData();
            this.$refs.grid.clearSearchBeforeSearchParam();
            this.$refs.grid.setSearchBeforeSearchParam(this.getSearchParam());
            this.$refs.grid.refurbish();
        },
        getSearchParam() {
            return this.$refs.quick.getData();
        },
        refurbish(ph_key) {
            if (ph_key) {
                this.ph_key = ph_key;
            } else {
                this.ph_key = '';
            }
            this.$refs.grid.refurbish();
        },
        gridOnSelectionChange(rows) {
            let obj = {};
            obj.name = 'gridOnSelectionChange';
            obj.para = rows;
            this.$emit('doAction', obj);
        },
        fromGridOnSelectionChange(rows) {
            let obj = {};
            obj.name = 'fromGridOnSelectionChange';
            obj.para = rows;
            this.$emit('doAction', obj);
        },
        gridOverrideData(data) {
            if (data && data.length > 0) {
                let self = this;
                this.$nextTick(() => {
                    let index = 0;
                    if (self.ph_key) {
                        let culIndex = data.findIndex(
              el => el[self.myConfig.bindingKey] === self.ph_key
            );
                        if (culIndex > -1) {
                            index = culIndex;
                        }
                    }
                    self.$refs.grid.setRowHighlight(index, true);
                    self.ph_key = data[index].ph_key;
                    self.initFromGrid(data[index]);
                    self.$refs.menutoolbar.setAllReadOnly(true);
                    self.$refs.menutoolbar.setReadOnly('editData', false);
                });
            } else {
                this.$refs.menutoolbar.setAllReadOnly(true);
                self.$refs.menutoolbar.setReadOnly('editData', false);
            }
            return data;
        },
        gridClick(e) {
            let obj = {};
            let self = this;
            obj.onOk = () => {
                self.ph_key = e.ph_key;
                self.initFromGrid(e);
                self.$refs.menutoolbar.setAllReadOnly(true);
                self.$refs.menutoolbar.setReadOnly('editData', false);
            };
            obj.onCancel = () => {
                if (self.ph_key) {
                    let data = self.$refs.grid.getData();
                    let culIndex = data.findIndex(
                        el => el[self.myConfig.bindingKey] === self.ph_key
                    );
                    if (culIndex > -1) {
                        self.$refs.grid.clearCurrentRow();
                        self.$nextTick(() => {
                            self.$refs.grid.setRowHighlight(culIndex, true);
                        });
                    }
                } else {
                    self.$refs.grid.clearCurrentRow();
                }
            };
            this.checkData(obj);
        },
        getForm() {
            return this.$refs.form;
        },
        getGrid() {
            return this.$refs.grid;
        },
        quickChagne() {
            this.ph_key = '';
            this.search();
        },
        getMenuToolbar() {
            return this.$refs.menutoolbar;
        },
        initFromGrid(para) {
            this.$refs.fromgrid.clearData();
            let data = this.getFromGridData(para);
            
            if (this.$parent.setBillData) {
                data = this.$parent.setBillData(data);
            }
            this.$refs.fromgrid.setData(data);
            this.$refs.fromgrid.setReadOnly(true);
            if (this.$parent.initFromGridAfter) {
                this.$parent.initFromGridAfter(data);
            }
        },
        getFromGridData(para) {
            let result = {};
            let self = this;
            if (!para.ph_key) {
                para.ph_key = this.ph_key;
            }
            self.synchroPost(
                self.myConfig.resources,
                self.myConfig.classPrefix + '.get',
                { ph_key: para.ph_key },
                function(data) {
                        result = data[self.myConfig.response][self.myConfig.fromGridConfig.response];
                        self.curlData =  Object.assign({},{},data[self.myConfig.response]);
                }
            );
            return result;
        },
        doAction(obj) {
            const method = obj.name;
            const methodBefore = method + 'Before';
            const methodAfter = method + 'After';
            if (
        obj.name === 'addData' ||
        obj.name === 'editData' ||
        obj.name === 'delData'
      ) {
                let flag = true;
                if (this.$parent[methodBefore]) {
                    flag = this.$parent[methodBefore]();
                }
                if (flag) {
                    if (obj.name === 'addData') {
                        let tmp = {};
                        if (flag !== true) {
                            tmp = flag;
                        }
                        this.$refs.fromgrid.addRow(tmp);
                    }
                    if (obj.name === 'editData') {
                        this.$refs.fromgrid.setReadOnly(false);
                        this.$refs.menutoolbar.setAllReadOnly(false);
                        this.$refs.menutoolbar.setReadOnly('editData', true);
                    }
                    if (obj.name === 'delData') {
                        this.$refs.fromgrid.delBatchRow();
                    }

                    if (this.$parent[methodAfter]) {
                        this.$parent[methodAfter]();
                    }
                }
            } else {
                if (obj.name === 'saveData') {
                    let data = this.$refs.fromgrid.getChangeData();
                    let tmp = Object.assign({},{},this.curlData);
                    tmp.flag = 'U';
                    tmp[this.myConfig.fromGridConfig.response] = data;
                    obj.para = [];
                    obj.para.push(tmp);
                    this.doCommonData(obj.para,methodAfter,'保存')
                }
                obj.onOk = this.onOk;
                this.$emit('doAction', obj);
            }
        },
        onOk(action, data) {
            if (action.name === 'saveData') {
                this.ph_key = data[0].ph_key;
                this.$refs.grid.refurbish();
                this.initForm(data[0]);
                this.$refs.menutoolbar.setReadOnly('editData', false);
                this.$refs.menutoolbar.setReadOnly('saveData', true);
            }
            if (action.name === 'delData') {
                this.ph_key = '';
                this.$refs.form.clearData();
                this.$refs.grid.refurbish();
                this.$refs.form.setReadOnly(true);
                this.$refs.menutoolbar.setAllReadOnly(false);
                this.$refs.menutoolbar.setReadOnly('saveData', true);
            }
        },
        checkData(obj) {
            let tempData = [];
            tempData = this.$refs.fromgrid.getChangeData();
            if (tempData && tempData.length>0) {
                let self = this;
                self.$Modal.confirm({
                    title: '确认',
                    content: '单据存在数据未确认，是否放弃？',
                    onOk: () => {
                         obj.onOk();
                    },
                    onCancel: () => {
                        if (obj.onCancel) {
                            obj.onCancel();
                        }
                    }
                });
            } else {
                 obj.onOk();
            }
        },
        setOutsideHeight () {
            let height = this.$refs.head.offsetHeight  + 32;
            this.$refs.grid.setOutsideHeight(height);
        },
        doCommonData(para,methodAfter,msg) {
            this.loading = true;
            let self = this;
            self.asyncPost(self.myConfig.resources,self.myConfig.classPrefix+ '.' + 'save' ,para,function(data) {
                self.alert(msg+'成功');
                self.$refs.menutoolbar.setAllReadOnly(true);
                self.$refs.menutoolbar.setReadOnly('editData', false);
                self.refurbish();
                if (self.$parent[methodAfter]) {
                    self.$parent[methodAfter]();
                }
                self.loading = false;   
            },function() {
                self.loading = false;
            });
        }
    },
    mounted() {
        this.observer = elementResizeDetectorMaker();
        this.observer.listenTo(this.$refs.head, this.setOutsideHeight);
        this.$nextTick(() => {
            this.$refs.menutoolbar.setAllReadOnly(true);
            this.$refs.menutoolbar.setReadOnly('editData', false);
            this.refurbish();

        });
    },
    beforeDestroy() {
        this.observer.removeListener(this.$refs.head, this.setOutsideHeight);
    }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/layouttemplate/leftlistrightlist.vue